import { KYMW9009Model } from '../kymw9009.model';
import { UserClassManagementModel } from '../vo/user-class-management.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * ユーザ階層管理削除コマンド
 * サーバーにユーザ階層管理更新をリクエストする。
 *
 * @export DeleteUserClassManagementService
 * @class DeleteUserClassManagementService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class DeleteUserClassManagementService extends PlessJsonResponderSub<any> {
  private model: KYMW9009Model = null;
  private voList: Array<UserClassManagementModel> = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteUserClassManagementService
   */
  private getBody(): PlessRequest {
    const request = {
      delete: {
        DeleteUserClassManagementList: {
          combination: []
        }
      }
    };
    this.voList.forEach((model) => {
      const vo: any = new Object();
      vo.condition = {
        ClassCode: model.ClassCode,
        GroupLeaderUserId: (model.GroupUserCheck || model.StaffUserCheck || model.AgentUserCheck) ? model.GroupUserIdOrigin : '',
        StaffUserId:       (model.StaffUserCheck || model.AgentUserCheck) ? model.StaffUserIdOrigin : '',
        AgentUserId:       (model.AgentUserCheck) ? model.AgentUserIdOrigin : ''
      };
      request.delete.DeleteUserClassManagementList.combination.push(vo);
    });
    return new PlessRequest(request);
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9009Model} model モデルクラス
   * @param {Array<UserClassManagementModel>} voList ユーザ階層管理VOリスト（送信対象に限定済み）
   * @memberof DeleteUserClassManagementService
   */
  execute(model: KYMW9009Model, voList: Array<UserClassManagementModel>) {
    this.model = model;
    this.voList = voList;
    this.send('deleteUserClassManagement', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteUserClassManagementService
   */
  success(data: any) {
    // 削除リクエスト後の処理を実施
    this.model.updateUserClassDeleted();
  }
}
